<!-- main app container -->
<div class="">
	
	<router-outlet></router-outlet>
	
</div>
